/**
 * The one way an error reaches the reader: the backend's own sentence, in a
 * red-soft box, with an optional way forward. Never a generic "etwas ist
 * schiefgelaufen" — the API always says what went wrong, and swallowing that
 * is how a tool loses trust.
 */
import { Button } from '@/components/ui/button'

export function ErrorNote({
  message,
  onRetry,
  retryLabel,
}: {
  message: string
  onRetry?: () => void
  retryLabel?: string
}) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-3 rounded-sm border border-signal-red/30 bg-signal-red-soft px-4 py-3 text-[13px] text-signal-red-text"
    >
      <span>{message}</span>
      {onRetry ? (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          {retryLabel}
        </Button>
      ) : null}
    </div>
  )
}
